// extracted by mini-css-extract-plugin
export var iconWrapper = "WasteHeader-module--iconWrapper--vhoM+";
export var imageWrapper = "WasteHeader-module--imageWrapper--ZrFzf";
export var wasteHeader = "WasteHeader-module--wasteHeader--H67vf";